import { Section } from "@/components/common/Section";
import { Container } from "@/components/common/Container";
import { SectionHeading } from "@/components/common/SectionHeading";
import { Reveal } from "@/components/common/Reveal";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { techGroups } from "@/data/tech.data";

/** Technology Stack — grouped by discipline via tabs (not a logo wall). */
export function TechStack() {
  return (
    <Section id="technology">
      <Container>
        <SectionHeading
          eyebrow="Technology"
          title="A modern stack, chosen deliberately"
          description="We pick tools for reliability and speed — not hype. Explore what powers the products we build."
          align="center"
        />

        <Reveal>
          <Tabs
            defaultValue={techGroups[0].category}
            className="mx-auto mt-12 w-full max-w-4xl"
          >
            <TabsList className="flex h-auto flex-wrap justify-center gap-2 bg-transparent p-0">
              {techGroups.map(({ category, icon: Icon }) => (
                <TabsTrigger
                  key={category}
                  value={category}
                  data-testid={`tech-tab-${category.toLowerCase()}`}
                  className="gap-2 rounded-full border border-border bg-card px-4 py-2 text-sm data-[state=active]:border-primary data-[state=active]:bg-primary data-[state=active]:text-primary-foreground data-[state=active]:shadow-none"
                >
                  <Icon className="h-4 w-4" />
                  {category}
                </TabsTrigger>
              ))}
            </TabsList>

            {techGroups.map(({ category, items }) => (
              <TabsContent
                key={category}
                value={category}
                className="mt-10 focus-visible:outline-none"
              >
                <div className="flex flex-wrap justify-center gap-3">
                  {items.map((item, i) => (
                    <span
                      key={item}
                      className="rounded-xl border border-border bg-card px-5 py-3 font-heading text-base font-semibold text-foreground transition-all duration-300 hover:-translate-y-0.5 hover:border-accent/40 hover:text-primary"
                      style={{ animationDelay: `${i * 40}ms` }}
                    >
                      {item}
                    </span>
                  ))}
                </div>
              </TabsContent>
            ))}
          </Tabs>
        </Reveal>
      </Container>
    </Section>
  );
}
